import { useState, useEffect } from 'react'
import { onAuthStateChanged, User } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { FBPATHS } from '@smorgrav/hundehall_shared'
import { auth, db } from '@/firebase'

/**
 * Current Firebase user plus whether they are a platform root (`admins/{uid}`
 * exists — the same predicate the backend's `isRoot` and the Firestore rules
 * use). `loading` stays true until both auth and the root check resolve, so the
 * shell never briefly renders for a not-yet-classified user.
 */
export function useAuthState() {
  const [user, setUser] = useState<User | null>(null)
  const [isRoot, setIsRoot] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    return onAuthStateChanged(auth, async (u) => {
      setUser(u)
      if (!u) {
        setIsRoot(false)
        setLoading(false)
        return
      }
      setLoading(true)
      try {
        // A user may read only their own admins/{uid} doc (Firestore rules).
        const snap = await getDoc(doc(db, FBPATHS.admins.doc(u.uid)))
        setIsRoot(snap.exists())
      } catch {
        setIsRoot(false)
      } finally {
        setLoading(false)
      }
    })
  }, [])

  return { user, isRoot, loading }
}
